import { Icon } from '@chakra-ui/icon';
export const RTMeLogo = props => {
  const css = `
    .st0 {
      fill: #FFFFFF;
    }
  `;
  return <Icon viewBox="0 0 98 18" {...props} data-sentry-element="Icon" data-sentry-component="RTMeLogo" data-sentry-source-file="RTMeLogo.tsx">
      <g data-sentry-element="g" data-sentry-source-file="RTMeLogo.tsx">
        <g data-sentry-element="g" data-sentry-source-file="RTMeLogo.tsx">
          <g data-sentry-element="g" data-sentry-source-file="RTMeLogo.tsx">
            <path className="st0" d="M62.6,6.5h0.8l1.7,3h0l1.7-3h0.8v5h-0.8V8.1h0l-1.4,2.4h-0.6l-1.4-2.4h0v3.4h-0.8L62.6,6.5L62.6,6.5z" data-sentry-element="path" data-sentry-source-file="RTMeLogo.tsx" />
            <path className="st0" d="M69,6.5h3.2v0.8h-2.3v1.4h1.8v0.8h-1.8v1.3h2.4v0.8H69C69,11.5,69,6.5,69,6.5z" data-sentry-element="path" data-sentry-source-file="RTMeLogo.tsx" />
          </g>
        </g>
        <g data-sentry-element="g" data-sentry-source-file="RTMeLogo.tsx">
          <path className="st0" d="M41,5.8c-0.1-0.1-0.3-0.2-0.4-0.2H35h-5.6c-0.2,0-0.5,0.2-0.5,0.4l-1.5,5.6l-1.5,5.6c0,0.2,0,0.3,0.1,0.5
            s0.3,0.2,0.4,0.2h5.6c0.2,0,0.5-0.2,0.5-0.4l1.4-5.2h5.2c0.2,0,0.5-0.2,0.5-0.4l1.5-5.6C41.2,6.2,41.1,6,41,5.8z M29.7,6.7h4.5
            L33,11.3h-4.5L29.7,6.7z M31.5,16.9H27l1.2-4.6h4.5L31.5,16.9z M38.7,11.3h-4.5l1.2-4.6h4.5L38.7,11.3z" data-sentry-element="path" data-sentry-source-file="RTMeLogo.tsx" />
          <path className="st0" d="M55.4,5.6h-4.9l1.3-4.9c0-0.2,0-0.3-0.1-0.5C51.6,0.1,51.5,0,51.3,0h-5.6c-0.2,0-0.5,0.2-0.5,0.4L43.6,6
            c0,0.2,0,0.3,0.1,0.5c0.1,0.1,0.3,0.2,0.4,0.2h4.9l-1.2,4.6h-5.2c-0.2,0-0.5,0.2-0.5,0.4l-1.5,5.6c0,0.2,0,0.3,0.1,0.5
            s0.3,0.2,0.4,0.2h5.6c0.2,0,0.5-0.2,0.5-0.4l1.4-5.2h5.2c0.2,0,0.5-0.2,0.5-0.4l1.5-5.6c0-0.2,0-0.3-0.1-0.5
            C55.8,5.7,55.6,5.6,55.4,5.6z M46.1,1.1h4.5l-1.2,4.6h-4.5L46.1,1.1z M46.3,16.9h-4.5l1.2-4.6h4.5L46.3,16.9z M53.5,11.3H49
            l1.2-4.6h4.5L53.5,11.3z" data-sentry-element="path" data-sentry-source-file="RTMeLogo.tsx" />
        </g>
      </g>

      <defs data-sentry-element="defs" data-sentry-source-file="RTMeLogo.tsx">
        <style>{css}</style>
      </defs>
    </Icon>;
};
RTMeLogo.displayName = 'RTMeLogo';